module.exports = __webpack_public_path__ + "img/icon_w_back.e89deb07.png";